/**
 * Styled Checkbox
 * 
 * @Author: Focci
 * @Date: 2023-04-17 10:47:58
 * @Last Modified by: Focci
 * @Last Modified time: 2023-04-17 10:47:58
 */

'use client'

// import PropTypes from 'prop-types'
import { forwardRef } from 'react'
import { Checkbox, FormControlLabel } from '@comp/material'
import clsx from 'clsx'

function StyledCheckbox({
  className = '',
  ...props
}, ref) {
  return (
    <FormControlLabel 
      control={<Checkbox ref={ref} className="mr-pix-4" />} 
      {...props} 
      className={clsx('!ml-0', className)} 
    />
  )
}

export default forwardRef(StyledCheckbox)
